<template>
  <div class="answer-wrapper" @mouseleave="showPopup = false">
    <div class="floating-wrapper-answers">
      <div class="dropdown ">
        <div class="answer" data-toggle="dropdown">
          <!--{{ answers[0].answer.answer | truncate(8) }}-->

          <span class="answer-text" v-if="matchedAnswer() !== undefined">
            <!--            | truncate(numOfTruncate)-->
            {{ matchedAnswer().answer.answer }}</span
          ><span v-else :class="{ adddepform: root === 'depForm' }"
            ><img
              class="plus"
              style="width: 14px;border-radius: 5px;"
              src="../.././../../../../assets/svg_icons/plus-square-regular.svg"
              alt=""
          /></span>
        </div>
        <ul class="dropdown-menu  answers-dropdown-menu">
          <input
            class="input-standard"
            type="search"
            placeholder="Search answer"
            v-model="answerQuery"
            @keyup="answerResults = filterFunction(answerQuery)"
          />
          <div class="dropdown-divider"></div>

          <div class="answer-menu-item re-checkbox" v-if="questionId === 1">
            <input
              type="checkbox"
              value="not chosen"
              id="re-checkbox"
              @change="
                clientRetired = $event.target.checked;
                updateRetired(clientRetired, client.id);
              "
              :checked="clientRetired"
            />
            <div
              @click="
                clientRetired = !clientRetired;
                updateRetired(clientRetired, client.id);
              "
              class="re-text"
              data-toggle="collapse"
              data-target="dropdown"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Retired
            </div>
          </div>
          <div
            id="collapseOne"
            class="collapse"
            aria-labelledby="headingOne"
            data-parent="#accordion"
          >
            sustainable VHS.
          </div>
          <div class="dropdown-divider" v-if="questionId === 1"></div>
          <div v-if="answerResults.length > 0 && answerQuery.length > 0">
            <li
              @click="
                matchedAnswer() !== undefined
                  ? updateAnswer(matchedAnswer().id, answer.id, client.id)
                  : saveAnswer(answer.id, client.id)
              "
              class="answer-menu-item"
              v-for="answer in answerResults"
              :key="answer.id"
            >
              {{ answer.answer }}
            </li>
          </div>
          <div v-if="answerResults.length === 0 || answerQuery.length === 0">
            <li
              @click="
                matchedAnswer() !== undefined
                  ? updateAnswer(
                      matchedAnswer().id,
                      answer.id,
                      client.id,
                      clientRetired
                    )
                  : saveAnswer(answer.id, client.id, clientRetired)
              "
              class="answer-menu-item"
              v-for="answer in dictionaries.general.client_questions[
                questionId - 1
              ].answers"
              :key="answer.id"
            >
              {{ answer.answer }}
            </li>
          </div>
        </ul>
      </div>
    </div>
    <!-- <a @click.prevent="$emit('delete')"
          ><span v-if="showRemove" class="fa fa-close remove-tag-icon"></span></a
          ></span>-->
    <div v-if="matchedLog().length === 0 && showPopup" class="answer-table">
      <div class="table-responsive">
        <table class="table">
          <tbody>
            <tr>
              <td>
                <strong>{{
                  dictionaries.general.client_questions[questionId - 1].question
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--    <div v-if="(matchedLog() !==undefined )&& (matchedLog().length > 0 && showPopup)" class="answer-table">-->
    <div v-if="false" class="answer-table">
      <div class="table-responsive">
        <table class="table">
          <tbody>
            <tr v-for="(item, idx) in matchedLog()" :key="idx">
              <!--              <td>{{ formatDateTable(matchedAnswer().updated_at) }}</td>
                        <td>{{ matchedAnswer().updated_at | shortTime }}</td>
                         <td class="td-answer">{{ matchedAnswer().answer.answer }}</td>
                        <td>{{ matchedAnswer().user.full_name }}</td>-->
              <td>{{ formatDateTable(item.updated_at) }}</td>
              <td>{{ item.updated_at | shortTime }}</td>
              <td>
                {{
                  dictionaries.general.client_questions[questionId - 1].question
                }}
              </td>
              <td class="td-answer">
                <span class="txt-answer">{{ item.answer.answer }}</span>
                <span class="txt-analogy" v-if="item.answer.analogy !== null">
                  | {{ item.answer.analogy }}</span
                >
              </td>
              <td>{{ item.user.full_name }}</td>
              <td v-if="questionId === 1 && client.retired === 1">
                <div class="retired-row">
                  <div>Retired</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import {
  setAnswer,
  updateAnswer,
  updateRetired
} from "../../api/clients_table.api";

export default {
  name: "ClientAnswer.component",

  props: {
    client: {
      type: Object,
      required: true
    },
    questionId: {
      type: Number,
      required: true
    },
    sendUpdated: {
      type: Boolean,
      default: () => false
    },
    root: {
      type: String
    },
    fromPopUp: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    ...mapState("clients", ["dictionaries"])
  },
  data() {
    return {
      showPopup: false,
      matchedAns: {},
      showDropDown: false,
      answerQuery: "",
      answerResults: [],
      answeringBusy: false,
      numOfTruncate: 6,
      clientRetired: false,
      retiredBusy: false,
      showFloatBox: false
    };
  },
  created() {
    if (this.root === "depForm") {
      this.numOfTruncate = 30;
    }
    if (this.root === "depositTag") {
      this.numOfTruncate = 10;
    }
    if (this.client.retired === 0) {
      this.clientRetired = false;
    }
    if (this.client.retired === 1) {
      this.clientRetired = true;
    }
    this.matchedLog();
  },

  methods: {
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY ");
    },

    matchedAnswer() {
      return this.client.answers.find(
        answer => answer.answer.question_id === this.questionId
      );
    },
    matchedLog() {
      return this.client.answers_log.filter(
        answer => answer.answer.question_id === this.questionId
      );
    },
    async saveAnswer(answerId, clientId) {
      if (this.answeringBusy === false) {
        this.answeringBusy = true;
        try {
          this.$store.commit("clients/setLoading", true);
          await setAnswer(answerId, clientId);
          this.$store.commit("clients/setLoading", false);
          this.answerResults = [];
          this.answerQuery = "";
          const block = localStorage.getItem("lock-client");
          //this.$emit("unlock");

          await this.$emit("updated");
          if (
            clientId === JSON.parse(block) &&
            this.client.answers.length > 8
          ) {
            //   alert()
            this.$emit("unlock");
          }
          /*          this.$store.commit("main/setShowVikiMsg", {
                          show: true,
                          msg: "Added New Answer",
                          type: "DONE"
                        });*/
          this.answeringBusy = false;
        } catch (e) {
          this.answerResults = [];
          this.answerQuery = "";
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg:
              "Set Answer Error!" + " " + " Error Status: " + e.response.status,
            type: "ERROR"
          });

          this.$store.commit("clients/setLoading", false);
        }
      }
    },
    async updateAnswer(itemId, answerId, clientId) {
      if (!this.answeringBusy) {
        this.answeringBusy = true;
        try {
          this.$store.commit("clients/setLoading", true);
          await updateAnswer(itemId, answerId, clientId);
          this.answerResults = [];
          this.answerQuery = "";
          this.$store.commit("clients/setLoading", false);
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg: "Answer Updated",
            type: "DONE"
          });
          await this.$emit("updated");
          this.componentKey += 1;
          this.answeringBusy = false;
        } catch (e) {
          this.answerResults = [];
          this.answerQuery = "";
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg:
              "Update/Change Answer Error!" +
              " " +
              " Error Status: " +
              e.response.status,
            type: "ERROR"
          });
          this.$store.commit("clients/setLoading", false);
        }
      }
    },

    async updateRetired(retired, clientId) {
      if (!this.retiredBusy) {
        this.retiredBusy = true;
        try {
          this.$store.commit("clients/setLoading", true);
          await updateRetired(retired, clientId);
          this.$store.commit("clients/setLoading", false);
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg: "Client Retired Status Updated",
            type: "DONE"
          });
          await this.$emit("updated");
          this.componentKey += 1;
          this.retiredBusy = false;
        } catch (e) {
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg:
              "Update/Change Client Retired Status Error!" +
              " " +
              " Error Status: " +
              e.response.status,
            type: "ERROR"
          });
          this.$store.commit("clients/setLoading", false);
        }
      }
    },

    filterFunction(userInput) {
      return this.dictionaries.general.client_questions[
        this.questionId - 1
      ].answers.filter(function(broker) {
        userInput = userInput.trim();
        userInput = userInput.toLowerCase();
        let afterRegex = userInput.replace(/[.*+\-?^${}()|[\]\\]/g, "");
        return broker.answer.toLowerCase().includes(afterRegex);
      });
      // filterList(q) {
      //   function escapeRegExp(s) {
      //     return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      //   }
      //
      //   const words = q
      //     .split(/\s+/g)
      //     .map(s => s.trim())
      //     .filter(s => !!s);
      //   const hasTrailingSpace = q.endsWith(" ");
      //   const searchRegex = new RegExp(
      //     words
      //       .map((word, i) => {
      //         if (i + 1 === words.length && !hasTrailingSpace) {
      //           return `(?=.*\\b${escapeRegExp(word)})`;
      //         } else {
      //           return `(?=.*\\b${escapeRegExp(word)}\\b)`;
      //         }
      //       })
      //       .join("") + ".+",
      //     "gi"
      //   );
      //   return this.dictionaries.general.client_questions[
      //     this.questionId - 1
      //   ].answers.filter(item => {
      //     return searchRegex.test(item.answer);
      //   });
    }
  }
};
</script>

<style scoped>
html * {
  font-family: "Montserrat" !important;
  /*  font-size: 10px;*/
  text-transform: uppercase;
}

.answer {
  cursor: pointer;
  text-align: center;
  font-size: 12px;
  min-width: 103px;
}

.answer-wrapper {
  display: inline;
  position: relative;
  text-align: center;
}

.floating-wrapper-answers {
  position: relative;
}

.answer-table {
  position: absolute;
  top: 0px;
  right: 40px;
  z-index: 10001;

  width: max-content;
  background-color: #fff;
  border: solid 1px #90a4ae;
  /*  border-radius: 5px;
  -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);*/
  /*-moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
  /*box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
}

.table-responsive {
  /* margin-bottom: -20px;*/
  border-radius: 5px;
}

.td-answer {
  font-weight: 600;
  word-break: break-word;
  max-width: 250px;
}

.answers-dropdown {
  width: max-content;
}

.answers-dropdown-menu {
  border: solid 1px #90a4ae;
  border-radius: 0;
  /*  left: -60px;*/
  position: absolute;
  max-width: 50px !important;
  -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
  /*-moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
  /*box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
}

.dropdown-menu {
  padding: 5px;
  height: auto;
  max-height: 500px;
  min-width: max-content;
  overflow-x: hidden;
  text-align: left;
}

.answer-menu-item {
  margin: 9px;
  font-size: 12px;
  text-transform: uppercase;
}

.answer-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}

.answer-text {
  cursor: pointer;
  text-align: left;
  font-size: 12px;
}

.input-standard {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  /*border-radius: 5px;*/
  font-family: "Montserrat" !important;
  border-style: solid;
  border-color: lightgray;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 11px;
  box-sizing: border-box;
  outline: none;
}

.dropdown-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.txt-answer {
  font-weight: 800;
}
.txt-analogy {
  font-size: 11px;
}
.adddepform {
  color: #96281b;
}
.re-checkbox {
  display: flex;
  justify-content: left;
  align-items: center;
}
.re-text {
  /*
    font-size: 9px;
*/
  margin-left: 4px;
  margin-top: 4px;
  text-transform: uppercase;
}
.retired-row {
  display: flex;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  background-color: #ebedee;
}
.plus {
  transition: all 0.3s ease-in-out;
}
.plus:hover {
  transform: scale(1.1);
  background-color: lightgrey;
}
</style>
